import { useState, useEffect, useRef } from "react";
import {
  FaHome,
  FaUserFriends,
  FaComments,
  FaUsers,
  FaBell,
  FaSignOutAlt,
  FaSearch,
  FaUser,
  FaArrowRight,
  FaTimes,
  FaBriefcase,
  FaShieldAlt
  , FaPlus
  , FaRegCommentDots
  , FaNetworkWired
  , FaCamera
  , FaVideo
  , FaLink
  , FaFileAlt
} from "react-icons/fa";
import "./Navbar.css";
import premiumCopy from '../premium/copy.json';
import logo from "../Assets/carrerup_profile_NoBg.png"
import brandLogo from "../Assets/carrerup_allInOne_cover_NoBg.png"
import { useNavigate } from "react-router-dom";
import { deleteData, clearRememberedSession } from "../store/Store";
import { get, patchRequest, post as postRequest } from '../http/api'
import { useConfirmModal } from "../components/reusable/ConfirmModalContext";
import { socket } from "../socket";
import NotificationUsersModal from "./NotificationUsersModal";
import PostModal from "./PostModal";
import { useTranslation } from "react-i18next";
import { API_URL, UPLOADS_URL } from "../config";
import { getMediaUrl } from "../http/media";
import { createPortal } from "react-dom";
import { unregisterMobilePush } from "../mobile/MobileRuntime";



export default function Navbar({ activeTab, setActiveTab, onHomeNavigation, notificationRequest }) {
  const [showNotif, setShowNotif] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const [billingStatus, setBillingStatus] = useState(null);
  const [billingLoading, setBillingLoading] = useState(false);

  const [showNativeCreate, setShowNativeCreate] = useState(false);

  const [preview, setPreview] = useState(null);

  const { openConfirmModal, closeModal } = useConfirmModal();

  const { t, i18n } = useTranslation();
  const visitCopy = premiumCopy[(i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0]] || premiumCopy.fr;
  const [mobileBrowserInset, setMobileBrowserInset] = useState(0);


  useEffect(() => {
    if (!showProfile) return;

    let cancelled = false;

    const loadBillingStatus = async () => {
      try {
        setBillingLoading(true);

        const response = await get("billing/status");

        if (!cancelled) {
          setBillingStatus(response.data || null);
        }
      } catch (error) {
        console.error("Unable to load billing status");
      } finally {
        if (!cancelled) {
          setBillingLoading(false);
        }
      }
    };

    loadBillingStatus();

    return () => {
      cancelled = true;
    };
  }, [showProfile]);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;

    let frame;
    const syncMobileBrowserInset = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const coveredBottom = Math.max(
          0,
          window.innerHeight - viewport.height - viewport.offsetTop
        );
        // iOS Safari can temporarily report almost the whole screen as
        // "covered" while its bars animate. Keep the dock accessible without
        // letting that transient value push it into the middle of the page.
        setMobileBrowserInset(Math.round(Math.min(88, coveredBottom)));
      });
    };

    syncMobileBrowserInset();
    viewport.addEventListener("resize", syncMobileBrowserInset);
    viewport.addEventListener("scroll", syncMobileBrowserInset);
    window.addEventListener("orientationchange", syncMobileBrowserInset);

    return () => {
      window.cancelAnimationFrame(frame);
      viewport.removeEventListener("resize", syncMobileBrowserInset);
      viewport.removeEventListener("scroll", syncMobileBrowserInset);
      window.removeEventListener("orientationchange", syncMobileBrowserInset);
    };
  }, []);


  const [notifUsersId, setNotifUsersId] = useState(null);

  const [openedPostId, setOpenedPostId] = useState(null);
  const [highlightedCommentId, setHighlightedCommentId] = useState(null);

  const [loadingNotifications, setLoadingNotifications] = useState(true);


  // Recherche users
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);


  // notifs
  const [notifications, setNotifications] = useState([]);
  const [notifUnreadCount, setNotifUnreadCount] = useState(0);

  const [openCommentsOnModal, setOpenCommentsOnModal] = useState(false);
  const [scrollLastComment, setScrollLastComment] = useState(false);

  const menuRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    if (showNotif) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showNotif]);


  const fetchNotifications = async () => {
    try {
      setLoadingNotifications(true);

      const res = await get("notifications");
      const data = Array.isArray(res?.data)
        ? res.data
        : [];

      setNotifications(data);

      const unread = data.filter(
        (n) => parseInt(n.is_read) === 0
      ).length;

      setNotifUnreadCount(unread);

    } catch (err) {
      console.error(err);
    } finally {
      setLoadingNotifications(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);


  const openNotifications = async () => {
    setShowNotif(true);
    setShowProfile(false);

    await fetchNotifications();
  };

  useEffect(() => {
    if (notificationRequest > 0) {
      openNotifications();
    }
  }, [notificationRequest]);


  // const formatNotif = (notif) => {
  //   switch (notif.type) {
  //     case "message_summary":
  //       return `${notif.count} ${notif.count > 1
  //         ? "messages non lus"
  //         : "message non lu"
  //         } `;

  //     case "post_like_summary": {
  //       if (notif.count <= 1) {
  //         return `${notif.last_sender_username} a aimé votre publication`;
  //       }

  //       return `${notif.last_sender_username} et ${notif.count - 1
  //         } autre${notif.count - 1 > 1 ? "s" : ""
  //         } ont aimé votre publication`;
  //     }

  //     case "post_comment_summary": {
  //       if (notif.count <= 1) {
  //         return `${notif.last_sender_username} a commenté votre publication`;
  //       }

  //       return `${notif.last_sender_username} et ${notif.count - 1
  //         } autre${notif.count - 1 > 1 ? "s" : ""} ont commenté votre publication`;
  //     }

  //     case "offer_match":
  //       return "Une offre correspond à votre profil";

  //     case "follow":
  //       return "a commencé à vous suivre";

  //     case "match":
  //       return "a matché avec vous";

  //     case "network_request":
  //       return "vous a envoyé une invitation";

  //     case "network_accept":
  //       return "a accepté votre invitation";

  //     case "profile_visit":
  //       return "a visité votre profil";

  //     case "mention_comment":
  //       return "vous a mentionné dans un commentaire";

  //     case "verification_success":
  //       return "Compte vérifié";

  //     default:
  //       return "Nouvelle notification";
  //   }
  // };

  const formatNotif = (notif) => {

    switch (notif.type) {

      case "message_summary":
        return `${notif.count} ${notif.count > 1
          ? t("notifications.messagesUnread")
          : t("notifications.messageUnread")
          }`;

      case "post_like_summary":

        if (notif.count <= 1) {

          return `${notif.last_sender_username} ${t(
            "notifications.likedPost"
          )}`;
        }

        return `${notif.last_sender_username} ${t(
          "notifications.likedPostOthers",
          {
            count: notif.count - 1
          }
        )}`;

      case "post_comment_summary":

        if (notif.count <= 1) {

          return `${notif.last_sender_username} ${t(
            "notifications.commentedPost"
          )}`;
        }

        return `${notif.last_sender_username} ${t(
          "notifications.commentedPostOthers",
          {
            count: notif.count - 1
          }
        )}`;

      case "offer_match":
        return t("notifications.offerMatch");

      case "follow":
        return t("notifications.follow");

      case "match":
        return t("notifications.match");

      case "network_request":
        return t("notifications.networkRequest");

      case "network_accept":
        return t("notifications.networkAccept");

      case "profile_visit":
        return notif.premium_required !== false ? visitCopy.locked : t("notifications.profileVisit");

      case "mention_comment":
        return t("notifications.mentionComment");

      case "verification_success":
        return t("notifications.verificationSuccess");

      default:
        return t("notifications.newNotification");
    }
  };


  useEffect(() => {

    const id =
      sessionStorage.getItem(
        "id_user"
      );
    if (id) {

      socket.emit(
        "join",
        id
      );
    }
    socket.on(
      "new_notification",
      (notif) => {
        if (notif.type === 'profile_visit') {
          fetchNotifications();
          return;
        }

        setNotifications(
          prev => [
            notif,
            ...prev
          ]
        );
        setNotifUnreadCount(
          prev => prev + 1
        );
      }
    );
    return () => {
      socket.off(
        "new_notification"
      );
    };
  }, []);


  const fetchPhoto = async () => {
    try {
      const res = await get("profile/photo");

      if (res.data?.photo_url) {
        setPreview(
          `${getMediaUrl(res.data.photo_url)}?t=${Date.now()}`
        );
      } else {
        setPreview(null);
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  /* FETCH CURRENT PHOTO */
  useEffect(() => {
    fetchPhoto();
  }, []);


  useEffect(() => {
    if (!search || search.trim().length < 1) {
      setResults([]);
      return;
    }

    const delay = setTimeout(async () => {
      try {
        setLoading(true);

        const response = await get(`users/search?q=${encodeURIComponent(search)}`);

        // FORCER UN TABLEAU
        const users = Array.isArray(response?.data)
          ? response.data
          : [];

        setResults(users);

      } catch (err) {
        console.error("Search error:", err);
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [search]);


  const navigate = useNavigate();

  const handleLogout = async () => {
    await unregisterMobilePush();
    clearRememberedSession();
    deleteData("id_user")
    deleteData("token")
    deleteData("user")
    navigate("/login")
  }

  // fonction pour confirmation de déconnexion
  const confirmLogout = () => {
    openConfirmModal({
      title: t("navbar.logoutTitle"),
      message: t("navbar.logoutMessage"),
      confirmText: t("navbar.logoutConfirm"),
      variant: "danger",
      cancelText: t("navbar.cancel"),
      onConfirm: async () => {
        await handleLogout();
        closeModal();
      },
    });
  };

  const navToSettings = () => {
    navigate('/settings')
  }

  const navToOffers = () => {

    navigate(
      "/offers"
    );

    setShowProfile(
      false
    );

  }

  const storedUser = sessionStorage.getItem("user");
  const usert = storedUser ? JSON.parse(storedUser) : null;


  // const formatTimeAgo = (dateString) => {
  //   const now = new Date();
  //   const date = new Date(dateString);
  //   const seconds = Math.floor(
  //     (now - date) / 1000
  //   );

  //   if (seconds < 60) {
  //     return t("timeAgo.justNow");
  //   }

  //   const minutes = Math.floor(seconds / 60);

  //   if (minutes < 60) {
  //     return `il y a ${minutes} min`;
  //   }

  //   const hours = Math.floor(minutes / 60);

  //   if (hours < 24) {
  //     return `il y a ${hours} h`;
  //   }

  //   const days = Math.floor(hours / 24);

  //   if (days < 7) {
  //     return `il y a ${days} ${days > 1 ? "jours" : "jour"
  //       }`;
  //   }

  //   const weeks = Math.floor(days / 7);

  //   if (weeks < 4) {
  //     return `il y a ${weeks} ${weeks > 1 ? "semaines" : "semaine"
  //       }`;
  //   }

  //   const months = Math.floor(days / 30);

  //   if (months < 12) {
  //     return `il y a ${months} ${months > 1 ? "mois" : "mois"
  //       }`;
  //   }

  //   const years = Math.floor(days / 365);

  //   return `il y a ${years} ${years > 1 ? "ans" : "an"
  //     }`;
  // };

  const formatTimeAgo = (dateString) => {

    const now = new Date();
    const date = new Date(dateString);

    const seconds =
      Math.floor(
        (now - date) / 1000
      );

    if (seconds < 60) {
      return t("timeAgo.justNow");
    }

    const minutes = Math.floor(seconds / 60);

    if (minutes < 60) {
      return t(
        "timeAgo.minutes",
        {
          count: minutes
        }
      );
    }

    const hours = Math.floor(minutes / 60);

    if (hours < 24) {
      return t(
        "timeAgo.hours",
        {
          count: hours
        }
      );
    }

    const days = Math.floor(hours / 24);

    if (days < 7) {

      return t(
        days > 1
          ? "timeAgo.days"
          : "timeAgo.day",
        {
          count: days
        }
      );
    }

    const weeks = Math.floor(days / 7);

    if (weeks < 4) {

      return t(
        weeks > 1
          ? "timeAgo.weeks"
          : "timeAgo.week",
        {
          count: weeks
        }
      );
    }

    const months = Math.floor(days / 30);

    if (months < 12) {

      return t(
        "timeAgo.month",
        {
          count: months
        }
      );
    }

    const years = Math.floor(days / 365);

    return t(
      years > 1
        ? "timeAgo.years"
        : "timeAgo.year",
      {
        count: years
      }
    );
  };


  const navToProfile = () => {
    navigate(`/user/${usert.username}`)
  }

  const navToAdmin = () => {
    setShowProfile(false);
    navigate("/admin");
  };

  const openNativeComposer = (type) => {
    setShowNativeCreate(false);
    setActiveTab("home");
    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent("carrerup:open-create-post", { detail: { type } }));
    }, 120);
  };


  const markNotificationAsRead = async (notif) => {

    // déjà lue
    if (parseInt(notif.is_read) === 1)
      return;

    // update immédiat
    setNotifications(prev =>
      prev.map(n =>
        n.id_notification ===
          notif.id_notification
          ? {
            ...n,
            is_read: 1
          }
          : n
      )
    );

    // update badge
    setNotifUnreadCount(prev =>
      Math.max(0, prev - 1)
    );

    try {

      await patchRequest(
        `notifications/${notif.id_notification}/read`
      );

    }
    catch (err) {

      console.error(err);

      // rollback si erreur

      setNotifications(prev =>
        prev.map(n =>
          n.id_notification ===
            notif.id_notification
            ? {
              ...n,
              is_read: 0
            }
            : n
        )
      );

      setNotifUnreadCount(
        prev => prev + 1
      );

    }

  };

  return (
    <nav className={`admin-dash-navbar ${activeTab === "home" ? "native-home-header" : "native-subpage-header"}`}>
      {activeTab === "home" && <div className="native-topbar" aria-label="CarrerUp">
        <button className="native-topbar-create" type="button" onClick={() => setShowNativeCreate(true)} aria-label={t("navbar.create")}>
          <FaPlus />
        </button>
        <img className="native-topbar-brand" src={brandLogo} alt="CarrerUp" />
        <div className="native-topbar-actions">
          <button type="button" onClick={() => setActiveTab("messages")} aria-label={t("navbar.messages")}>
            <FaRegCommentDots />
          </button>
          <button type="button" className="native-notification-button" onClick={openNotifications} aria-label={t("navbar.notifications")}>
            <FaBell />
            {notifUnreadCount > 0 && <span>{notifUnreadCount > 9 ? "9+" : notifUnreadCount}</span>}
          </button>
        </div>
      </div>}
      {/* LEFT */}
      <div className="admin-dash-navbar-left">
        <img
          src={logo}
          alt="CarrerUp"
          className="admin-dash-navbar-logo"
          width={50}
          height={50}
        />

        <div className="admin-dash-navbar-search">
          <FaSearch />
          <input
            type="text"
            placeholder={t("navbar.searchUser")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          {/* CLEAR ICON */}
          {search && (
            <FaTimes
              className="search-clear-icon"
              onClick={() => {
                setSearch("");
                setResults([]);
              }}
            />
          )}

          {/* Dropdown for search */}
          {search && (
            <div className="admin-dash-search-dropdown">
              {loading && <p className="search-loading"> {t("navbar.searching")} </p>}

              {!loading && results.length === 0 && (
                <p className="search-empty"> {t("navbar.userNotFound")} </p>
              )}

              {!loading && results.map(user => (
                <button
                  type="button"
                  key={user.id}
                  className="search-item"
                  onClick={() => {
                    navigate(`/user/${user.username}`);
                    setSearch("");
                    setResults([]);
                  }}
                >
                  <span className="search-item-avatar">
                    {user?.image ? (
                      <img
                        // src={`${UPLOADS_URL}/${user.image}`}
                        src={getMediaUrl(user.image)}
                        alt={user.username || t("navbar.user")}
                      />
                    ) : (
                      <FaUser />
                    )}
                  </span>
                  <span className="search-item-content">
                    <strong>{user.username}</strong>
                    <small>@{user.username}</small>
                  </span>
                  <FaArrowRight className="search-item-arrow" />
                </button>
              ))}
            </div>
          )}


        </div>
      </div>

      {/* CENTER */}

      <div className="admin-dash-navbar-center">
        <div
          className={`admin-dash-nav-icon ${activeTab === "home" ? "active" : ""}`}
          onClick={onHomeNavigation}
        >
          <FaHome />
          <span>{t("navbar.home")}</span>
        </div>

        <div
          className={`admin-dash-nav-icon ${activeTab === "matching" ? "active" : ""}`}
          onClick={() => setActiveTab("matching")}
        >
          <FaUserFriends />
          <span>{t("navbar.matching")}</span>
        </div>

        <div
          className={`admin-dash-nav-icon ${activeTab === "messages" ? "active" : ""}`}
          onClick={() => setActiveTab("messages")}
        >
          <FaRegCommentDots />
          <span>{t("navbar.messages")}</span>
        </div>

        <div
          className={`admin-dash-nav-icon ${activeTab === "network" ? "active" : ""}`}
          onClick={() => setActiveTab("network")}
        >
          <FaNetworkWired />
          <span>{t("navbar.network")}</span>
        </div>

      </div>

      {/* RIGHT */}
      <div className="admin-dash-navbar-right" >
        {/* NOTIFICATIONS */}
        <div className="admin-dash-icon-wrapper" onClick={(e) => e.stopPropagation()}>
          <div
            className="notif-bell-wrap"
            onClick={() => {
              if (showNotif) {
                setShowNotif(false);
              } else {
                openNotifications();
              }
            }}
          >
            <FaBell />

            {notifUnreadCount > 0 && (
              <span className="notif-badge">
                {notifUnreadCount > 9
                  ? "9+"
                  : notifUnreadCount}
              </span>
            )}
          </div>

          {createPortal(
            <>
              <div
                className={`notif-overlay ${showNotif ? "show" : ""}`}
                onClick={() => setShowNotif(false)}
              />

              <div className={`notif-drawer ${showNotif ? "open" : ""}`}>
                <div className="notif-header">
                  <div>
                    <h3>{t("navbar.notifications")}</h3>
                    <p>{t("navbar.notificationsSubtitle")}</p>
                  </div>

                  <button
                    className="notif-close"
                    onClick={() => setShowNotif(false)}
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="notif-list">
                  {loadingNotifications ? (
                    <div className="notif-skeleton-list">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <div
                          key={i}
                          className="notif-skeleton-item"
                        >
                          <div className="notif-sk-avatar skeleton"></div>

                          <div className="notif-sk-content">
                            <div className="notif-sk-line skeleton"></div>
                            <div className="notif-sk-line short skeleton"></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : notifications.length === 0 ? (
                    <p>{t("navbar.noNotifications")}</p>
                  ) : (
                    Array.isArray(notifications) &&
                    notifications.map((notif) => (
                      <div
                        key={notif.id_notification}
                        className={`notif-card ${parseInt(notif.is_read) === 0
                          ? "unread"
                          : ""
                          }`}

                        onClick={async () => {
                          await markNotificationAsRead(
                            notif
                          );

                          if (notif.type === "post_like_summary") {
                            setOpenCommentsOnModal(false);
                            setScrollLastComment(false);
                            setOpenedPostId(notif.entity_id);
                            return;
                          }

                          if (notif.type === "post_comment_summary") {

                            setHighlightedCommentId(
                              notif.comment_id
                            );
                            setOpenCommentsOnModal(true);
                            setScrollLastComment(false);
                            setOpenedPostId(notif.entity_id);
                            return;
                          }

                          if (
                            notif.type === "follow"
                          ) {
                            navigate(`/user/${notif.username}`);
                            setShowNotif(false);
                            return;
                          }

                          if (
                            notif.type === "offer_match"
                          ) {

                            navigate(
                              `/offers/${notif.entity_id}`
                            );

                            setShowNotif(false);

                            return;
                          }

                          if (notif.type === "profile_visit") {
                            navigate(`/home?profileVisit=${encodeURIComponent(notif.id_notification)}`);
                            setShowNotif(false);
                            return;
                          }

                          if (notif.type === "mention_comment") {

                            setHighlightedCommentId(
                              notif.comment_id
                            );
                            setOpenCommentsOnModal(true);
                            setScrollLastComment(false);
                            setOpenedPostId(notif.entity_id);
                            return;
                          }

                        }
                        }
                      >

                        {parseInt(notif.is_read) === 0 && (
                          <div className="notif-dot"></div>
                        )}


                        <strong
                          className={
                            notif.type === "post_like_summary" &&
                              notif.count > 1
                              ? "notif-clickable"
                              : ""
                          }
                          onClick={(e) => {
                            if (notif.type === 'profile_visit') return;
                            e.stopPropagation();
                            if (
                              (
                                notif.type === "post_like_summary" ||
                                notif.type === "post_comment_summary"
                              ) && notif.count > 1
                            ) {
                              setNotifUsersId(
                                notif.id_notification
                              );
                            }
                          }}
                        >
                          {notif.type === 'profile_visit' && notif.premium_required !== false ? visitCopy.notificationTitle : notif.type === "message_summary"
                            ? formatNotif(notif)
                            : notif.type === "post_like_summary"
                              ? formatNotif(notif)
                              : notif.username || "CarrerUp"}
                        </strong>

                        <p>
                          {notif.type === "message_summary"
                            ? t("notifications.viewInbox")
                            : notif.type === "post_like_summary"
                              ? t("notifications.viewPost")
                              : formatNotif(notif)}
                        </p>

                        <small>
                          {formatTimeAgo(notif.created_at)}
                        </small>

                        {notif.type === "follow" &&
                          Number(notif.isFollowingBack) === 0 && (
                            <button
                              className="notif-follow-back-btn"
                              onClick={async (e) => {
                                e.stopPropagation();

                                try {
                                  await postRequest(
                                    `follows/${notif.sender_id}`
                                  );

                                  setNotifications(prev =>
                                    prev.map(n =>
                                      n.id_notification === notif.id_notification
                                        ? {
                                          ...n,
                                          isFollowingBack: 1
                                        }
                                        : n
                                    )
                                  );

                                } catch (err) {
                                  console.error(err);
                                }
                              }}
                            >
                              {t("navbar.followBack")}
                            </button>
                          )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </>,
            document.body
          )}
        </div>

        {/* PROFILE */}
        <div className="admin-dash-icon-wrapper" ref={menuRef}>


          {preview === null && loading ? (
            <div className="skeleton avatar"></div>
          ) : preview ? (
            <img
              onClick={() => {
                setShowProfile(!showProfile);
                setShowNotif(false);
              }}
              src={preview}
              style={{ width: "25px", height: "25px", borderRadius: "50%" }}
            // className="post-user-avatar"
            />
          ) : (
            <FaUser
              className="post-user-icon"
              onClick={() => {
                setShowProfile(!showProfile);
                setShowNotif(false);
              }}
            />
          )}

          {showProfile && (
            <div className="admin-dash-dropdown admin-dash-profile-menu">
              <div className={`admin-dash-profile-header admin-dash-profile-item ${activeTab === "account" ? "active" : ""}`}
                onClick={navToProfile}
              >
                {preview === null && loading ? (
                  <div className="skeleton avatar"></div>
                ) : preview ? (
                  <img
                    src={preview}
                    style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                  />
                ) : (
                  <FaUser className="post-user-icon" />
                )}
                <span> {usert.username} </span>
              </div>

              <div
                className={`admin-dash-subscription ${billingStatus?.premium ? "premium" : "free"
                  }`}
                onClick={() => {
                  setShowProfile(false);
                  navigate("/billing");
                }}
              >
                <div className="subscription-icon">
                  {billingStatus?.premium ? "✦" : "C"}
                </div>

                <div className="subscription-info">
                  {billingLoading ? (
                    <span className="subscription-loading">
                      Chargement...
                    </span>
                  ) : billingStatus?.premium ? (
                    <>
                      <strong>CarrerUp Premium</strong>

                      <span>
                        {billingStatus.lifetime
                          ? "Premium à vie"
                          : billingStatus.plan === "yearly"
                            ? "Plan annuel"
                            : billingStatus.plan === "monthly"
                              ? "Plan mensuel"
                              : "Plan Premium"}
                      </span>
                    </>
                  ) : (
                    <>
                      <strong>CarrerUp Free</strong>
                      <span>Plan gratuit · Passer à Premium</span>
                    </>
                  )}
                </div>

                <FaArrowRight className="subscription-arrow" />
              </div>

              {usert?.isAdmin === 1 && (
                <div
                  className="admin-dash-profile-item admin-panel-menu-item"
                  onClick={navToAdmin}
                >
                  <FaShieldAlt />

                  <span>
                    Administration
                  </span>
                </div>
              )}

              {usert?.role === "club" && (
                <div
                  className="admin-dash-profile-item"
                  onClick={navToOffers}
                >
                  <FaBriefcase /> {t("navbar.offers")}
                </div>

              )}

              <div className="admin-dash-profile-item admin-dash-logout" onClick={confirmLogout}>
                <FaSignOutAlt /> {t("navbar.logout")}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* MOBILE BOTTOM NAV */}
      {createPortal(
        <div
          className="mobile-bottom-nav"
          style={{ "--mobile-browser-inset": `${mobileBrowserInset}px` }}
        >
          <div onClick={onHomeNavigation} className={activeTab === "home" ? "active" : ""}>
            <FaHome />
            <span>{t("navbar.home")}</span>
          </div>

          <div onClick={() => setActiveTab("matching")} className={activeTab === "matching" ? "active" : ""}>
            <FaUserFriends />
            <span>{t("navbar.matching")}</span>
          </div>

          <div className={`mobile-native-only ${activeTab === "search" ? "active" : ""}`} onClick={() => setActiveTab("search")}>
            <FaSearch />
            <span>{t("navbar.search")}</span>
          </div>

          <div className={`mobile-web-only ${activeTab === "messages" ? "active" : ""}`} onClick={() => setActiveTab("messages")}>
            <FaRegCommentDots />
            <span>{t("navbar.messages")}</span>
          </div>

          <div onClick={() => setActiveTab("network")} className={activeTab === "network" ? "active" : ""}>
            <FaNetworkWired />
            <span>{t("navbar.network")}</span>
          </div>

          <div className="mobile-native-only" onClick={navToProfile}>
            <FaUser />
            <span>{t("navbar.profile")}</span>
          </div>

        </div>,
        document.body
      )}

      {showNativeCreate && createPortal(
        <div className="native-create-overlay" onClick={() => setShowNativeCreate(false)}>
          <section className="native-create-sheet" onClick={(event) => event.stopPropagation()}>
            <header>
              <div>
                <small>CarrerUp</small>
                <h2>{t("navbar.create")}</h2>
              </div>
              <button type="button" onClick={() => setShowNativeCreate(false)}><FaTimes /></button>
            </header>
            <div className="native-create-grid">
              <button type="button" onClick={() => openNativeComposer("post")}><FaCamera /><span>{t("feed.post")}</span></button>
              <button type="button" onClick={() => openNativeComposer("video")}><FaVideo /><span>{t("feed.video")}</span></button>
              <button type="button" onClick={() => openNativeComposer("link")}><FaLink /><span>{t("feed.link")}</span></button>
              <button type="button" onClick={() => openNativeComposer("text")}><FaFileAlt /><span>{t("feed.text", { defaultValue: "Texte" })}</span></button>
              {usert?.role === "club" && <button type="button" onClick={() => openNativeComposer("offer")}><FaBriefcase /><span>{t("feed.offer")}</span></button>}
            </div>
          </section>
        </div>,
        document.body
      )}

      {notifUsersId && (
        <NotificationUsersModal
          notificationId={notifUsersId}
          onClose={() =>
            setNotifUsersId(null)
          }
        />
      )}


      {openedPostId && (
        <PostModal
          postId={openedPostId}
          openComments={openCommentsOnModal}
          scrollToLastComment={scrollLastComment}
          highlightedCommentId={highlightedCommentId}
          onClose={() => {
            setOpenedPostId(null);
            setOpenCommentsOnModal(false);
            setScrollLastComment(false);
          }}
        />
      )}

    </nav>
  );
}
